import { render, staticRenderFns } from "./termsAndService.vue?vue&type=template&id=680af396&scoped=true&"
import script from "./termsAndService.vue?vue&type=script&lang=js&"
export * from "./termsAndService.vue?vue&type=script&lang=js&"
import style0 from "./termsAndService.vue?vue&type=style&index=0&id=680af396&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680af396",
  null
  
)

export default component.exports